<template>
  <div class="project-deteil-box">
    <div class="project-control">
      <i
        :id="`projectDeteil${project._id}`"
        class="el-icon-s-tools"
        style="font-size: 20px;color: #409eff;"
        @click="showDropdown(project, `projectDeteil${project._id}`)"
      ></i>
    </div>
    <div class="project-level">
      <el-tooltip v-if="project.客户分类" placement="top">
        <div slot="content" class="grade-detail">
          <div v-for="(item, label) in gradeType" :key="label" class="grade-detail-item">
            <p>
              <span class="label">{{ label }}:</span>
              <span class="num">{{ getGrade(item, project.客户打分明细) }}分</span>
            </p>
          </div>
          <div class="grade-detail-item">
            <span class="label">综合评分:</span> <span class="num">{{ getGrade(null, project.客户打分明细) }}分</span>
          </div>
        </div>
        <span class="letter">{{ project.客户分类 || '请完善' }}</span>
      </el-tooltip>
      <span v-else class="letter-2">请完善</span> <span>项目评分</span>
    </div>
    <div class="project-deteil" @click="showProject">
      <div class="mb5">
        <p class="project-label">{{ project.项目名称 }}</p>
        <p class="project-label">{{ project.客户公司 }}</p>
      </div>
      <!-- <div class="mb5"><el-rate v-model="project.优先级" disabled text-color="#ff9900"></el-rate></div> -->
      <div class="mb5">
        <el-tag v-if="project.职能模块" size="mini" class="mr5 mb5">{{ project.职能模块 }}</el-tag>
        <el-tag v-for="(item, ind) in project.地域" :key="ind" size="mini" type="info" class="mr5 mb5">
          {{ item }}
        </el-tag>
        <el-tag v-if="project.职级 == 1 || project.职级 == 2" size="mini" type="warning" class="mr5 mb5">高端</el-tag>
        <el-tag size="mini" type="warning" v-if="project['保密']" class="project-tag">保密</el-tag>
        <el-tag size="mini" type="warning" v-if="project['独家']" class="project-tag">独家</el-tag>
        <el-tag size="mini" type="warning" v-if="project['替换']" class="project-tag">替换</el-tag>
        <el-tag size="mini" type="warning" v-if="project['新建']" class="project-tag">新建</el-tag>
        <el-tag size="mini" type="warning" v-if="project['紧急重要']" class="project-tag">紧急重要</el-tag>
        <el-tag size="mini" type="warning" v-if="project['刚需必成']" class="project-tag">刚需必成</el-tag>
      </div>
      <div class="mb5" @click.stop>
        <p class="project-label">编号：{{ project.编号 }}</p>
      </div>
    </div>
    <div class="project-progress">
      <div :class="[project.项目状态 === '已失败' ? 'gray-gray' : 'white-blue', 'days']">
        <div class="project-step-container" style="width:90px;">
          <span class="days-num">{{ passed(project.startTime || project.createdAt) || '--' }}天</span>
          <span class="days-label keep-all">项目进展</span>
        </div>
        <div class="triangle"></div>
      </div>
      <div
        v-for="(stepName, index) in progress"
        :key="stepName"
        :class="[step >= index ? 'active' : '', getStepColor(step, index), 'project-step']"
        @click="toShowStep(step >= index, stepName)"
      >
        <div v-if="step >= index" class="project-step-container">
          <div class="project-step-container-half">
            <!-- tooltip 小黑框 -->
            <p>
              <el-tooltip placement="top">
                <TooltipContent
                  slot="content"
                  :project="project"
                  :get-pipeline="getPipeline"
                  :step="stepName"
                  :days="computingDay(stepName)"
                ></TooltipContent>
                <el-badge is-dot :hidden="!badge[stepName]">
                  <span class="project-step-name keep-all">{{ translateStepName[stepName] || stepName }}</span>
                </el-badge>
              </el-tooltip>
              <BadgeNum :project="project" :get-pipeline="getPipeline" :step="stepName" :days="computingDay(stepName)">
              </BadgeNum>
            </p>
            <span v-if="step >= index && getPipeline" class="keep-all">{{ computingTime(stepName) }}</span>
          </div>
          <div class="project-step-container-half">
            <span
              v-if="step >= index && stepName === '人才搜寻'"
              :class="[getPipeline && computingDay(stepName) > 2 ? 'step-warning' : '', 'project-step-feedback-btn']"
              @click.stop="clickMark(stepName)"
            >
              <i v-if="getPipeline && computingDay(stepName) > 2" class="el-icon-warning project-step-icon"></i>
              人才搜寻反馈
            </span>
            <span
              v-if="step >= index && stepName === '职位推荐'"
              :class="[getPipeline && computingDay(stepName) > 4 ? 'step-warning' : '', 'project-step-feedback-btn']"
              @click.stop="clickMark(stepName)"
            >
              <i v-if="getPipeline && computingDay(stepName) > 4" class="el-icon-warning project-step-icon"></i>
              职位推荐反馈
            </span>
          </div>
        </div>
        <div v-else class="project-step-container">
          <div class="project-step-container-half">
            <span class="project-step-name keep-all">{{ translateStepName[stepName] || stepName }}</span>
            <span v-if="step >= index && getPipeline" class="keep-all">{{ computingTime(stepName) }}</span>
          </div>
          <div class="project-step-container-half">
            <span
              v-if="step >= index && stepName === '人才搜寻' && getPipeline && computingDay(stepName) > 2"
              style="color:#ff0000"
              @click.stop="clickMark(stepName)"
            >
              <i class="el-icon-warning project-step-icon"></i> 人才搜寻反馈
            </span>
            <span
              v-if="step >= index && stepName === '职位推荐' && getPipeline && computingDay(stepName) > 4"
              style="color:#ff0000"
              @click.stop="clickMark(stepName)"
            >
              <i class="el-icon-warning project-step-icon"></i> 职位推荐反馈
            </span>
          </div>
        </div>
        <div class="triangle"><div class="triangle-inside"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipContent from './projectProgress/TooltipContent'
import BadgeNum from './projectProgress/BadgeNum'

const obj = {
  公司综合评分: ['公司平台', '公司口碑'],
  职位综合评分: ['职级', '地域', '职位薪酬'],
  职位操作难度: ['业务线', '面试环节', '合理度', '附加维度'],
  数据匹配度: ['数据库', '领域熟悉度'],
  合作价值评分: ['猎头竞争度', '合作模式-费率'],
}
const 评分标准 = {
  公司平台: [
    { label: '大平台', value: '大平台', grade: 10 },
    { label: '中平台', value: '中平台', grade: 5 },
    { label: '小平台', value: '小平台', grade: 0 },
  ],
  公司口碑: [
    { label: '好', value: '好', grade: 8 },
    { label: '中', value: '中', grade: 4 },
    { label: '坏', value: '坏', grade: -4 },
  ],
  职级: [
    { label: 'MD及高管', value: '高管', grade: 5 },
    { label: 'SVP到ED', value: 'SVP到ED', grade: 3 },
    { label: 'AN到VP', value: 'AN到VP', grade: 0 },
  ],
  地域: [
    { label: '北上广深', value: '北上广深', grade: 2 },
    { label: '一线城市', value: '一线', grade: 1 },
    { label: '非一线城市', value: '非一线', grade: -1 },
    { label: '定点一个非一线城市', value: '定点非一线', grade: -2 },
  ],
  职位薪酬: [
    { label: '市场平均75%及以上', value: '75', grade: 10 },
    { label: '市场平均50%', value: '50', grade: 5 },
    { label: '市场平均25及以下', value: '25', grade: -5 },
  ],
  业务线: [
    { label: '能接触到业务直线经理', value: '能', grade: 3 },
    { label: '不能接触到业务直线经理', value: '不能', grade: 0 },
  ],
  面试环节: [
    { label: '面试轮数少于等于2轮', value: '2及以下', grade: 4 },
    { label: '面试3轮及以上', value: '2以上', grade: 2 },
  ],
  合理度: [
    { label: '客户要求高，很挑剔', value: '高', grade: -10 },
    { label: '客户要求较高，有一定合理度', value: '较高', grade: 5 },
    { label: '客户要求合理，刚需', value: '合理', grade: 10 },
  ],
  附加维度: [
    { label: '6个月保证期', value: '保证期', grade: -3 },
    { label: '有离职退款条款', value: '离职条款', grade: -3 },
    { label: '预付费条款', value: '预付费条款', grade: 3 },
  ],
  数据库: [
    { label: '数据库支持5天内找到', value: '5天内', grade: 10 },
    { label: '数据库支持10天内找到', value: '10天内', grade: 5 },
    { label: '无相关数据', value: '无数据', grade: -5 },
  ],
  领域熟悉度: [
    { label: '在你的熟悉领域&可以和其他职位一起做', value: '熟悉', grade: 10 },
    { label: '非熟悉领域', value: '非熟悉', grade: 5 },
  ],
  猎头竞争度: [
    { label: '独家职位', value: '独家', grade: 15 },
    { label: '有其他猎头，但竞争度不强', value: '竞争不强', grade: 10 },
    { label: '有多家猎头竞争', value: '多家竞争', grade: -5 },
    { label: '多家猎头竞争，开始很久了', value: '竞争已久', grade: -10 },
  ],
  '合作模式-费率': [
    { label: '25%以上费率', value: '高', grade: 10 },
    { label: '24%及以下费率', value: '中', grade: 5 },
    { label: '20%及以下费率', value: '低', grade: -5 },
  ],
}
const gradeMap = {}
for (const field in 评分标准) {
  const arr = 评分标准[field]
  arr.forEach(v => {
    gradeMap[`${field}${v.value}`] = v.grade
  })
}

const dateFormat = require('dateformat')

export default {
  components: { TooltipContent, BadgeNum },
  props: {
    project: { type: Object, default: () => ({}) },
    showDropdown: { type: Function, default: () => {} },
    showStep: { type: Function, default: () => {} },
    showRadishSearchMark: { type: Function, default: () => {} },
    showPositionRecommendMark: { type: Function, default: () => {} },
    getPipeline: { type: Boolean, default: false },
  },
  data() {
    return {
      translateStepName: { 项目创建: '项目详情' },
      progress: ['项目创建', '人才搜寻', '职位推荐', '面试阶段', 'offer谈判', '离职管理', '开票催款'],
      reportType: 'mapping',
      changes: {},
      dialogVisible: false,
      // dialogTitle: undefined,
      // true 展示 false 不展示，与badge组件hidden属性相反
      badge: { 项目创建: false },
      gradeType: obj,
      gradeStandard: 评分标准,
      gradeMap: gradeMap,
    }
  },
  computed: {
    step() {
      const steps = ['项目创建', '人才搜索', '职位推荐', '面试阶段', 'offer谈判', '离职管理', '开票催款']
      const index = steps.findIndex(val => this.project.项目阶段 === val)
      return index !== -1 ? index : 0
    },
    accounts() {
      return window.app.accounts || []
    },
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        if (newValue && !newValue.优先级) {
          newValue.优先级 = 0
        }
        if ((newValue && newValue._id) !== (oldValue && oldValue._id)) {
          this.progress.forEach(v => this.stepShowBadge(v))
        }
      },
      immediate: true,
    },
  },

  methods: {
    getGrade(val, grade) {
      const { gradeStandard, gradeMap } = this
      const fields = val || Object.keys(gradeStandard)
      let num = 0
      fields.forEach(field => {
        const arr = grade[field]
        arr.forEach(v => {
          num += gradeMap[`${field}${v}`]
        })
      })
      return num
    },
    stepShowBadge(stepName) {
      // true 展示 false 不展示，与badge组件hidden属性相反
      const { project, badge } = this
      // ['项目创建', '人才搜寻', '职位推荐', '面试阶段', 'offer谈判', '离职管理', '开票催款']
      if (stepName === '项目创建') {
        const storage = localStorage.getItem('hasCheckProject')
        const obj = (storage && JSON.parse(storage)) || {}
        const time = new Date('2020-04-24').getTime()
        const account = app.user.account
        badge[stepName] = account !== project.创建人 && project.createdAt > time && !obj[project._id]
      }
    },
    showProject() {
      window.open(`${window.origin}/#/project20/${this.project._id}`)
    },
    async clickMark(stepName) {
      await app.service('project').saveRecords({ type: stepName, path: '点击项目阶段', page: '项目列表' })
      if (stepName === '人才搜寻') this.showRadishSearchMark(this.project)
      else if (stepName === '职位推荐') this.showPositionRecommendMark(this.project)
    },
    toShowStep(isShow, stepName) {
      if (!isShow) return
      if (stepName === '项目创建' && this.badge[stepName]) this.badge[stepName] = false
      this.showStep(this.project, stepName)
      // this.$emit('showStep', { project: this.project, step: stepName })
    },
    async updateProject(params, cb) {
      if (!this.project._id) return
      const param =
        typeof params === 'string'
          ? {
              [params]: this.changes[params] || null,
            }
          : params
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        this.$emit('updateProject', param)
        cb && cb()
        this.$message({ type: 'success', message: `修改成功` })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    getStepColor(step, index) {
      if (this.project.项目状态 === '已失败') return 'gray-gray'

      if (index > step && index !== 6) return 'gray-gray'
      else if (index > step && index === 6) return 'gray-white'
      if (index === 0) {
        if (step === 0) return 'blue-gray'
        else return 'blue-green'
      } else if (index > 0 && index < 4) {
        if (step > index) return 'green-green'
        else return 'green-gray'
      } else if (index === 4) {
        if (step === 4) return 'green-gray'
        else return 'green-origin'
      } else if (index === 5) {
        if (step === 5) return 'origin-gray'
        else return 'origin-origin'
      } else if (index === 6) {
        return 'origin-white'
      }
    },
    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
    countDays(ms) {
      return Math.ceil(ms / (1000 * 60 * 60 * 24))
    },
    computingTime(step) {
      const copyProject = window._.cloneDeep(this.project)
      let { radish_project: radishProject = [], recommends = [], interviews = [], toworks = [] } = copyProject
      copyProject.offers = copyProject.offers || []
      const today = new Date().getTime()
      ;[radishProject, recommends, interviews, copyProject.offers, toworks].forEach(val => {
        val.sort((a, b) => a.createdAt - b.createdAt)
      })
      radishProject = radishProject.filter(v => !v.isDeleted)
      recommends = recommends.filter(v => !v.isDeleted)
      interviews = interviews.filter(v => !v.isDeleted)
      const offers = copyProject.offers.filter(v => !v.isDeleted && !v.isMaybe)
      const maybeOffers = copyProject.offers.filter(v => !v.isDeleted && v.isMaybe)
      toworks = toworks.filter(v => !v.isDeleted)
      const finalInterviews = interviews.filter(val => val.isFinal)
      const finalInterview = finalInterviews[0]

      let offerNegotiateStart
      if (maybeOffers[0] && finalInterview) {
        offerNegotiateStart =
          maybeOffers[0].createdAt < finalInterview.createdAt ? maybeOffers[0].createdAt : finalInterview.createdAt
      } else if (maybeOffers[0] || finalInterview) {
        offerNegotiateStart = (maybeOffers[0] || finalInterview).createdAt
      } else if (offers.length > 0) {
        const thisInterviews = interviews.filter(v => v.rid === offers[0].rid)
        offerNegotiateStart = thisInterviews[thisInterviews.length - 1].createdAt
      }

      if (step === '项目创建') {
        const lastDay = radishProject.length > 0 ? radishProject[0].createdAt : today
        return this.getStepTemplate(this.project, lastDay)
      } else if (step === '人才搜索' || step === '人才搜寻') {
        const lastDay = recommends.length > 0 ? recommends[0].createdAt : today
        return this.getStepTemplate(radishProject[0], lastDay)
      } else if (step === '职位推荐') {
        const lastDay = interviews.length > 0 ? interviews[0].createdAt : today
        return this.getStepTemplate(recommends[0], lastDay)
      } else if (step === '面试阶段') {
        // const lastDay = finalInterview ? finalInterview.createdAt : today
        const lastDay = offerNegotiateStart || today
        return this.getStepTemplate(interviews[0], lastDay)
        //   lastDay - interviews[0].createdAt,
        // )}天`
      } else if (step === 'offer谈判') {
        const lastDay = offers.length > 0 ? offers[0].createdAt : today
        // const firstDay = finalInterview || interviews[interviews - 1]
        const firstDay = { createdAt: offerNegotiateStart }
        return this.getStepTemplate(firstDay, lastDay)
      } else if (step === '离职管理') {
        const lastDay = toworks.length > 0 ? toworks[0].createdAt : today
        return this.getStepTemplate(offers[0], lastDay)
      } else if (step === '开票催款') {
        const lastDay = this.project.endTime || today
        return this.getStepTemplate(toworks[0], lastDay)
      }
      //  else if (step === '离职管理') {
      //   const lastDay = recommends.length > 0 ? recommends[0].createdAt : today
      //   return `${dateFormat(radishProject[0].createdAt, 'yyyy-mm-dd')} ${this.countDays(
      //     lastDay - radishProject[0].createdAt,
      //   )}天`
      // } else if (step === '开票催款') {
      //   const lastDay = recommends.length > 0 ? recommends[0].createdAt : today
      //   return `${dateFormat(radishProject[0].createdAt, 'yyyy-mm-dd')} ${this.countDays(
      //     lastDay - radishProject[0].createdAt,
      //   )}天`
      // }
    },
    computingDay(step) {
      const copyProject = window._.cloneDeep(this.project)
      let { radish_project: radishProject = [], recommends = [], interviews = [], toworks = [] } = copyProject
      copyProject.offers = copyProject.offers || []
      const today = new Date().getTime()
      ;[radishProject, recommends, interviews, copyProject.offers, toworks].forEach(val => {
        val.sort((a, b) => a.createdAt - b.createdAt)
      })
      radishProject = radishProject.filter(v => !v.isDeleted)
      recommends = recommends.filter(v => !v.isDeleted)
      interviews = interviews.filter(v => !v.isDeleted)
      const offers = copyProject.offers.filter(v => !v.isDeleted && !v.isMaybe)
      const maybeOffers = copyProject.offers.filter(v => !v.isDeleted && v.isMaybe)
      toworks = toworks.filter(v => !v.isDeleted)
      const finalInterviews = interviews.filter(val => val.isFinal)
      const finalInterview = finalInterviews[0]

      let offerNegotiateStart
      if (maybeOffers[0] && finalInterview) {
        offerNegotiateStart =
          maybeOffers[0].createdAt < finalInterview.createdAt ? maybeOffers[0].createdAt : finalInterview.createdAt
      } else if (maybeOffers[0] || finalInterview) {
        offerNegotiateStart = (maybeOffers[0] || finalInterview).createdAt
      } else if (offers.length > 0) {
        const thisInterviews = interviews.filter(v => v.rid === offers[0].rid)
        offerNegotiateStart = thisInterviews[thisInterviews.length - 1].createdAt
      }

      if (step === '项目创建') {
        const lastDay = radishProject.length > 0 ? radishProject[0].createdAt : today
        return this.project && this.project.createdAt ? this.countDays(lastDay - this.project.createdAt) : 0
      } else if (step === '人才搜索' || step === '人才搜寻') {
        const lastDay = recommends.length > 0 ? recommends[0].createdAt : today
        return radishProject[0] && radishProject[0].createdAt ? this.countDays(lastDay - radishProject[0].createdAt) : 0
      } else if (step === '职位推荐') {
        const lastDay = interviews.length > 0 ? interviews[0].createdAt : today
        return recommends[0] && recommends[0].createdAt ? this.countDays(lastDay - recommends[0].createdAt) : 0
      } else if (step === '面试阶段') {
        const lastDay = offerNegotiateStart || today
        return interviews[0] && interviews[0].createdAt ? this.countDays(lastDay - interviews[0].createdAt) : 0
      } else if (step === 'offer谈判') {
        const lastDay = offers.length > 0 ? offers[0].createdAt : today
        // const firstDay = finalInterview || interviews[interviews - 1]
        const firstDay = { createdAt: offerNegotiateStart }
        return firstDay ? this.countDays(lastDay - firstDay.createdAt) : 0
      } else if (step === '离职管理') {
        const lastDay = toworks.length > 0 ? toworks[0].createdAt : today
        return offers[0] && offers[0].createdAt ? this.countDays(lastDay - offers[0].createdAt) : 0
      } else if (step === '开票催款') {
        const lastDay = this.project.endTime || today
        return toworks[0] && toworks[0].createdAt ? this.countDays(lastDay - toworks[0].createdAt) : 0
      }
    },
    getStepTemplate(begin, over) {
      // return begin && begin.createdAt
      //   ? `${dateFormat(begin.createdAt, 'yyyy-mm-dd')} （${this.countDays(over - begin.createdAt)}）天`
      //   : ''
      return begin && begin.createdAt ? `${dateFormat(begin.createdAt, 'yyyy-mm-dd')}` : ''
    },
  },
}
</script>

<style scoped>
.step-warning {
  color: #ff0000;
}
.project-deteil-box {
  display: flex;
  padding-left: 15px;
  padding-right: 10px;
  margin-bottom: 8px;
  border: 1px solid #eee;
  box-shadow: 1px 0px 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.project-deteil {
  width: 200px;
  flex-shrink: 0;
  cursor: pointer;
  background-color: #e8f3fa;
  padding: 10px;
}
.project-control {
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  flex-shrink: 0;
}
.project-level {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 4px;
  width: 30px;
  flex: none;
  word-break: break-all;
  text-align: center;
}
.project-level .letter {
  display: inline-block;
  padding: 0 7px;
  margin-top: 2px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  word-break: keep-all;
  background-color: #409eff;
  color: #fff;
}
.project-level .letter-2 {
  display: inline-block;
  padding: 2px 6px;
  margin-top: 2px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  word-break: keep-all;
  background-color: #409eff;
  color: #fff;
  font-size: 12px;
  width: 24px;
  word-break: break-all;
}

.project-btn {
  color: #409eff;
  cursor: pointer;
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.project-btn,
.project-control > span {
  color: #409eff;
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  -ms-flex-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  align-items: center;
}

.project-btn:hover {
  color: #fff;
  background-color: #409eff;
  cursor: pointer;
}
.project-label {
  font-weight: 700;
  font-size: 14px;
  margin-right: 5px;
}
.project-step-container-half {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.project-step,
.days {
  display: flex;
  height: 100px;
  font-size: 14px;
}
.triangle {
  position: relative;
  border-left: 40px solid #fff;
  border-top: 50px solid transparent !important;
  border-bottom: 50px solid transparent !important;
}
.triangle:before {
  content: '';
  width: 4px;
  display: block;
  height: 100px;
  background-color: #fff;
  transform: translate(-44px, -50px);
}
.triangle-inside {
  position: absolute;
  top: -50px;
  left: -44px;
  border-left: 40px solid;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
}
/* .triangle:after {
  content: '';
  position: absolute;
  position: absolute;
  top: -50px;
  left: -22px;
  border-left: 20px solid #fff;
  border-top: 50px solid transparent !important;
  border-bottom: 50px solid transparent !important;
} */
.project-step-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  width: 135px;
  position: relative;
}

.project-step-name {
  font-size: 16px;
  font-weight: 700;
}
.project-step-icon {
  color: #cf0202;
  /* position: absolute;
  top: 10px;
  right: 10px; */
  font-size: 18px;
  cursor: pointer;
}
.project-progress {
  display: flex;
  align-self: center;
}
.days-num {
  padding: 6px 4px;
  font-size: 14px;
  border-radius: 6px;
  font-weight: 800;
  color: #fff;
  background-color: #409eff;
}
.days-label {
  font-weight: 700;
  font-size: 14px;
  margin-top: 4px;
}
.project-step-feedback-btn {
  border: 1px solid;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.white-blue {
  background-color: #fff;
}
.white-blue .triangle {
  border-left-color: #fff;
  border-top-color: #409eff !important;
  border-bottom-color: #409eff !important;
}
.white-blue .triangle-inside {
  border-left-color: #fff;
}
.blue-gray,
.blue-green {
  background-color: #409eff;
}
.blue-gray,
.blue-green {
  color: #fff;
}

.blue-gray .triangle-inside,
.blue-green .triangle-inside {
  border-left-color: #409eff;
}
.blue-gray .triangle {
  border-left-color: #fff;
  border-top-color: #ddd !important;
  border-bottom-color: #ddd !important;
}
.blue-green .triangle {
  border-left-color: #fff;
  border-top-color: #aff3af !important;
  border-bottom-color: #aff3af !important;
}

.green-green,
.green-origin,
.green-gray {
  background-color: #aff3af;
  color: #336600;
}
.green-green .triangle-inside,
.green-origin .triangle-inside,
.green-gray .triangle-inside {
  border-left-color: #aff3af;
}
.green-green .triangle {
  border-left-color: #fff;
  border-top-color: #aff3af !important;
  border-bottom-color: #aff3af !important;
}
.green-origin .triangle {
  border-left-color: #fff;
  border-top-color: #fdbb78 !important;
  border-bottom-color: #fdbb78 !important;
}
.green-gray .triangle {
  border-left-color: #fff;
  border-top-color: #ddd !important;
  border-bottom-color: #ddd !important;
}

.origin-gray,
.origin-origin,
.origin-white {
  background-color: #fdbb78;
}
.origin-gray .triangle-inside,
.origin-origin .triangle-inside,
.origin-white .triangle-inside {
  border-left-color: #fdbb78;
}
.origin-gray .triangle {
  border-left-color: #fff;
  border-top-color: #ddd !important;
  border-bottom-color: #ddd !important;
}
.origin-origin .triangle {
  border-left-color: #fff;
  border-top-color: #fdbb78 !important;
  border-bottom-color: #fdbb78 !important;
}
.origin-white .triangle {
  border-left-color: #fff;
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
}

.gray-gray,
.gray-white {
  background-color: #ddd;
  color: #757575;
}

.gray-gray .triangle-inside,
.gray-white .triangle-inside {
  border-left-color: #ddd;
}
.gray-gray .triangle {
  border-left-color: #fff;
  border-top-color: #ddd !important;
  border-bottom-color: #ddd !important;
}
.gray-white .triangle {
  border-left-color: #fff;
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
}
.grade-detail {
  display: flex;
  flex-wrap: wrap;
  /* width: 300px; */
}
.grade-detail-item {
  width: 50%;
  margin-bottom: 4px;
  display: flex;
  padding: 5px;
  border-radius: 4px;
}
.grade-detail .label {
  width: 90px;
  flex: none;
  display: inline-block;
}
.grade-detail .num {
  font-weight: 700;
  margin-left: 10px;
}
.grade-detail-count {
  background-color: #eee;
}
</style>
